import { createAsyncThunk } from '@reduxjs/toolkit'
import logout from 'api/user/logout'
import { removeSessionKey } from 'storage/sessionKey'

interface LogoutUserConfig {
    skipLogoutLegacyApp?: boolean
    skipRedirect?: boolean
}

const logoutUser = createAsyncThunk(
    'user/logout',
    async (params?: LogoutUserConfig) => {
        if (!params?.skipLogoutLegacyApp) {
            /* @ts-expect-error: this was set in IFrameSync.ts */
            window.authenticatorIFrameClient.logout()
        }

        await logout()

        // Remove potential session key from localstorage.
        removeSessionKey()

        // shutting LiveChat down
        if (window.Intercom) window.Intercom('shutdown')

        if (!params?.skipRedirect) window.location.hash = '#/'
    },
)

export default logoutUser
